import { useNavigate } from "react-router-dom";
import { CardRouded } from "../../Atoms/CardRounded";
import { ButtonV2 } from "../../Atoms/ButtonV2";

export const Auth = () => {
  const navigate = useNavigate();

  return (
    <div className="py-12">
      <p className="text-center mb-8">
        Faça o <strong>login</strong> ou <strong>cadastre-se</strong> para
        agender sua vistoria.
      </p>

      <div className="flex flex-wrap gap-6 justify-center">
        <CardRouded className=" max-w-[500px] ">
          <div className="flex flex-col gap-6 items-center">
            <img
              alt="icone user redondo"
              src="/assets/svgs/icon-user-rouded.svg"
            />
            <div className="text-center">
              <h1 className="text-xl font-extrabold mb-2">Já sou cliente</h1>
              <p className="text-sm">
                Acesse com seus dados para agendar mais rápido
              </p>
            </div>

            <ButtonV2
              className="w-full"
              onClick={() => navigate("/agendamento/auth/login")}
            >
              Fazer Login
              <img
                alt="icone seta para direita"
                src="/assets/svgs/icon-arrow-forward.svg"
              />
            </ButtonV2>
          </div>
        </CardRouded>

        <CardRouded className="max-w-[500px]">
          <div className="flex flex-col gap-6 items-center">
            <div>
              <img
                alt="icone user redondo"
                src="/assets/svgs/icon-user-rouded-plus.svg"
              />
            </div>

            <div className="text-center">
              <h1 className="text-xl font-extrabold mb-2">Novo por aqui?</h1>
              <p className="text-sm">Crie seu cadastro em poucos segundos</p>
            </div>

            <ButtonV2
              className="w-full"
              onClick={() => navigate("/agendamento/auth/cadastro-usuario")}
            >
              Criar Cadastro
            </ButtonV2>
          </div>
        </CardRouded>
      </div>
    </div>
  );
};
